import React, { useEffect, useState, useMemo } from 'react';
import { useParams } from 'react-router-dom';
import { trackPromise, usePromiseTracker } from 'react-promise-tracker';
import { Alert, Page } from 'vetrf-ui';
import { Grid } from '@mui/material';
import { CheckDataLoading } from 'components/CheckDataLoading/CheckDataLoading';
import { EntryType } from 'components/registry/types/api';
import { FileType } from 'types/types';
import { pharmPermissionsApi } from '../../api';
import { PermitObjectStatus } from '../../../types';
import { PharmPermissionDTO } from '../../types/types';
import { ViewForm } from '../../components/ViewForm';
import { getBreadcrumbs, VIEW_TITLE } from '../utils';

const ViewRecordAndRequest = () => {
  const { promiseInProgress } = usePromiseTracker();
  const [data, setData] = useState<PharmPermissionDTO<FileType>>();
  const [error, setError] = useState('');
  const { id } = useParams();

  const fetchData = async () => {
    setError('');
    await pharmPermissionsApi
      .getCard(id!)
      .then(setData)
      .catch((err) => setError(err.response.data.message));
  };

  const entryType = useMemo(() => {
    switch (data?.status?.code) {
      case PermitObjectStatus.GRANTED:
      case PermitObjectStatus.CHANGING:
      case PermitObjectStatus.EXPIRED:
        return EntryType.registry;
      default:
        return EntryType.requests;
    }
  }, [data]);

  const updateData = async () => {
    trackPromise(fetchData());
  };

  useEffect(() => {
    updateData();
  }, []);

  return (
    <Page
      title={VIEW_TITLE}
      breadcrumbs={
        data ? getBreadcrumbs(`/registry/pharmPermissions/${entryType}`, id!, false, entryType) : []
      }
      header={VIEW_TITLE}
      subHeader={data && data.recipient.shortName}
    >
      <Grid container>
        <Grid item xs={12}>
          {error ? (
            <Alert closable messageType="danger">
              {error}
            </Alert>
          ) : (
            <CheckDataLoading condition={!promiseInProgress && !!data}>
              <ViewForm
                data={data!}
                registryLink={`/registry/pharmPermissions/${entryType}`}
                entryType={entryType}
                updateData={updateData}
              />
            </CheckDataLoading>
          )}
        </Grid>
      </Grid>
    </Page>
  );
};
export default ViewRecordAndRequest;
